/**
 * Hello Ava
 *
 * Copyright © 2016-2017 Helloava, Inc. All rights reserved.
 *
 * Filename: configureLayerStore.js
 *
 * Created by robertcaslin.
 */

import { combineReducers, createStore, applyMiddleware, compose } from 'redux';


import helloava from '../reducers';
import { routerReducer, routerMiddleware } from 'react-router-redux'
import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger';

const loggerMiddleware = createLogger();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState, history) {
    const middleware = routerMiddleware(history);
    return createStore(combineReducers({helloava, router:routerReducer}), initialState,
        composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware, middleware))
    );


}



// WEBPACK FOOTER //
// ./src/store/configureStore.js